import { Edit, ImageField, ImageInput, NumberInput, SimpleForm, TextInput, BooleanInput, ReferenceArrayInput, SelectArrayInput } from 'react-admin';
import { Grid, Typography, Box } from '@mui/material';

const PlanEdit = () => {

	return (
		<Edit>
			<SimpleForm width={'100%'}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h6">תמונה</Typography>
					</Grid>
					<Grid item xs={12}>
						<ImageField source="image" sx={{ 
							'& image': { 
								maxWidth: '100%', 
								maxHeight: 200, 
								objectFit: 'contain' 
							} 
						}} />
					</Grid>
					<Grid item xs={12}>
						<ImageInput source="image" label="תמונה" accept="image/*">
							<ImageField source="src" />
						</ImageInput>
					</Grid>




					<Grid item xs={12}>
						<Typography variant="h6">תמונה רצה</Typography>
					</Grid>
					<Grid item xs={12}>
						<ImageField source="prev_image" sx={{ 
							'& image': { 
								maxWidth: '100%', 
								maxHeight: 200, 
								objectFit: 'contain' 
							} 
						}} />
					</Grid>
					<Grid item xs={12}>
						<ImageInput source="prev_image" label="תמונה רצה" accept="image/*">
							<ImageField source="src" />
						</ImageInput>
					</Grid>


					<Grid item xs={12}>
						<Typography variant="h6">כותרת</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="title.he" label="כותרת (עברית)" fullWidth dir="rtl" />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="title.en" label="כותרת (אנגלית)" fullWidth dir="ltr" />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">תת כותרת</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="sub_title.he" label="תת כותרת (עברית)" fullWidth dir="rtl" />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="sub_title.en" label="תת כותרת (אנגלית)" fullWidth dir="ltr" />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">סיבה</Typography>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="reason.he" label="סיבה (עברית)" fullWidth dir="rtl" />
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextInput source="reason.en" label="סיבה (אנגלית)" fullWidth dir="ltr" />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="h6">פרטים</Typography>
					</Grid>
					<Grid item xs={12} sm={3}>
						<NumberInput source="days" label="ימים" fullWidth required />
					</Grid>
					<Grid item xs={12} sm={3}>
						<NumberInput source="amount" label="כמות תכנים" fullWidth />
					</Grid>
					<Grid item xs={12} sm={3}>
						<NumberInput source="videoamount" label="כמות וידאו" fullWidth />
					</Grid>
					<Grid item xs={12} sm={3}>
						<NumberInput source="missionamount" label="כמות משימות" fullWidth />
					</Grid>
					<Grid item xs={12} sm={3}>
						<NumberInput source="expertamount" label="כמות מומחים" fullWidth />
					</Grid>
					<Grid item xs={12} sm={3}>
						<BooleanInput source="active" label="פעיל" />
					</Grid>
					<Box width="100%" />
					<Grid item xs={12}>
						<Typography variant="h6" sx={{ mt: 3, mb: 2 }}>פרסים</Typography>
					</Grid>
					<Grid item xs={12} sm={4}>
						<ReferenceArrayInput
							source="prizes1"
							reference="ai-program-prize"
							label="פרסים 1"
							perPage={999}
							fullWidth
						>
							<SelectArrayInput 
								optionText={(record: any) => `${record.title?.he || record._id}`}
								optionValue="_id"
								fullWidth
							/>
						</ReferenceArrayInput>
					</Grid>
					<Grid item xs={12} sm={4}>
						<ReferenceArrayInput
							source="prizes2"
							reference="ai-program-prize"
							label="פרסים 2"
							perPage={999}
							fullWidth
						>
							<SelectArrayInput 
								optionText={(record: any) => `${record.title?.he || record._id}`}
								optionValue="_id"
								fullWidth
							/>
						</ReferenceArrayInput>
					</Grid>
					<Grid item xs={12} sm={4}>
						<ReferenceArrayInput
							source="prizes3"
							reference="ai-program-prize"
							label="פרסים 3"
							perPage={999}
							fullWidth
						>
							<SelectArrayInput 
								optionText={(record: any) => `${record.title?.he || record._id}`}
								optionValue="_id"
								fullWidth
							/>
						</ReferenceArrayInput>
					</Grid>
				</Grid>
			</SimpleForm>
		</Edit>
	);
};
export default PlanEdit;
